// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"246c96a8","590":"7ad468d1"}[chunkId] + ".chunk.js";
};